import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import { afterTracking } from "../tracker";
function isVisitorStats(value) {
  if (typeof value !== "object" || value === null) return false;
  return ["total", "today", "yesterday", "online"].every(key => {
    const count = value[key];
    return typeof count === "number" && Number.isSafeInteger(count) && count >= 0;
  });
}
export default class XgayVisitorCounter extends Component {
  stats = null;
  unsubscribe = null;
  removed = false;
  requestId = 0;
  oninit(vnode) {
    super.oninit(vnode);
    this.unsubscribe = afterTracking(() => void this.load());
    void this.load();
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.removed = true;
    this.unsubscribe?.();
  }
  async load() {
    const requestId = ++this.requestId;
    try {
      const stats = await app.request({
        method: "GET",
        url: app.forum.attribute("apiUrl") + "/visitor-counter/stats",
        errorHandler: () => {}
      });
      if (!this.removed && requestId === this.requestId && isVisitorStats(stats)) {
        this.stats = stats;
        m.redraw();
      }
    } catch {
      // Keep the last valid counters if the statistics endpoint is unavailable.
    }
  }
  view() {
    return m("div", {
      className: "XgayFooter"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "XgayFooter-content VisitorCounter"
    }, this.stats && m("div", {
      className: "VisitorCounter-inner"
    }, this.item("fas fa-eye", "Tổng lượt xem", this.stats.total), this.item("fas fa-calendar-day", "Hôm nay", this.stats.today), this.item("fas fa-calendar-minus", "Hôm qua", this.stats.yesterday), this.item("fas fa-circle", "Đang online", this.stats.online, "online")))));
  }
  item(icon, label, value, className) {
    if (className === void 0) {
      className = "";
    }
    return m("div", {
      className: "VisitorCounter-item " + className
    }, m("i", {
      className: "icon " + icon,
      "aria-hidden": "true"
    }), m("span", {
      className: "VisitorCounter-label"
    }, label), m("strong", null, value.toLocaleString()));
  }
}
flarum.reg.add('xgay-visitor-counter', 'forum/components/XgayVisitorCounter', XgayVisitorCounter);